
import { defineComponent, PropType } from "@vue/runtime-core";

export default defineComponent({
  emits: ["modify"],
  props: {
    name: String,
    value: { type: Number, required: true },
    disabled: Boolean,
    min: Number,
    max: Number,
    step: Number,
    id: String,
    valueTranslation: Object as PropType<{ [key: number]: string | number }>,
  },

  computed: {
    displayValue() {
      if (this.valueTranslation) {
        return this.valueTranslation[this.value];
      }
      return this.value;
    },
  },
});
